import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  TextField,
  Stack
} from '@mui/material';
import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useTeam } from '../../contexts/TeamContext';

export default function AddTeamMemberDialog({ open, onClose }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('');
  const [jobFunction, setJobFunction] = useState('');
  const { user } = useAuth();
  const { addTeamMember, setSelectedMember } = useTeam();

  const handleSubmit = async () => {
    try {
      if (!user) {
        throw new Error('No authenticated user');
      }

      const newTeamMember = {
        name,
        email,
        role,
        jobFunction,
        managerId: user.uid
      };

      const addedMember = await addTeamMember(newTeamMember);
      
      // Automatically select the newly added team member
      setSelectedMember(addedMember);

      // Reset form
      setName('');
      setEmail('');
      setRole('');
      setJobFunction('');
      
      onClose();
    } catch (error) {
      console.error('Error adding team member:', error);
    }
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Team Member</DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 2 }}>
          <TextField
            autoFocus
            label="Name"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            label="Email"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={email !== '' && !isValidEmail(email)}
            helperText={email !== '' && !isValidEmail(email) ? 'Invalid email address' : ''}
          />
          <TextField
            label="Role"
            fullWidth
            value={role}
            onChange={(e) => setRole(e.target.value)}
          />
          <TextField
            label="Job Function"
            fullWidth
            value={jobFunction}
            onChange={(e) => setJobFunction(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained"
          disabled={!name || !email || !role || !jobFunction || !isValidEmail(email)}
        >
          Add Team Member
        </Button>
      </DialogActions>
    </Dialog>
  );
}
